import React from 'react';
import PipelineTaskList from '../pipeline-task-list/index';

// 任务页面 - 直接显示 Pipeline 任务列表
const TaskPage: React.FC = () => {
  return <PipelineTaskList />;
};

export default TaskPage;
